import { FormattedMessage } from 'react-intl';

export default function CookiesDisabledAlert() {
  return (
    <div role="alert" className="rounded-xl border border-amber-100 bg-amber-50/80 p-4">
      <p className="text-sm text-amber-700">
        <FormattedMessage id="auth.signIn.cookiesDisabled" />
      </p>
    </div>
  );
}
